import React from 'react'

export default function PracticePrompt(props) {
    return (
        <div className="prompt mb-3 font-italic">
            <b>{props.prompt}</b>
        </div>
    )
}
